/** HUD-Teil: Lebenskraft, Vorrat, Erfahrung. */

import type { Schnappschuss } from '@pg/protocol';
import { el, type HudTeil } from './typen.js';

export const balken: HudTeil = {
  name: 'balken',
  aktualisieren(_u, s: Schnappschuss) {
    const leben = el<HTMLDivElement>('.balken.leben');
    const anteil = Math.max(0, s.spieler.leben / s.spieler.lebenMax);
    (leben.querySelector('i') as HTMLElement).style.width = `${anteil * 100}%`;
    (leben.querySelector('span') as HTMLElement).textContent =
      `${Math.ceil(s.spieler.leben)} / ${s.spieler.lebenMax}`;
    // Unter einem Viertel wird der Balken unruhig — die einzige Stelle, an der
    // die Oberflaeche laut wird.
    leben.classList.toggle('knapp', anteil < 0.25);

    (el<HTMLDivElement>('.balken.vorrat').querySelector('i') as HTMLElement).style.width =
      `${(s.spieler.vorrat / s.spieler.vorratMax) * 100}%`;
    (el<HTMLDivElement>('.balken.erfahrung').querySelector('i') as HTMLElement).style.width =
      `${(s.spieler.erfahrung / Math.max(1, s.spieler.erfahrungNaechste)) * 100}%`;
  },
};
